import { shiftDate } from '../../bs-moment/utils/date-setters';
export function createMatrix(options, fn) {
    var prevValue = options.initialDate;
    var matrix = new Array(options.height);
    for (var i = 0; i < options.height; i++) {
        matrix[i] = new Array(options.width);
        for (var j = 0; j < options.width; j++) {
            matrix[i][j] = fn(prevValue);
            prevValue = shiftDate(prevValue, options.shift);
        }
    }
    return matrix;
}
//# sourceMappingURL=matrix-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/utils/matrix-utils.js
// module id = 222
// module chunks = 33